module.exports = __webpack_public_path__ + "img/song-preview.9d81c173.jpg";